import { Link } from "react-router-dom";
import { CircleX } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <main className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center bg-white border border-border rounded-3xl p-8 md:p-10" data-testid="payment-cancel-page">
        <div className="w-16 h-16 mx-auto rounded-full grid place-items-center bg-muted text-foreground/60">
          <CircleX className="w-8 h-8" strokeWidth={2.2} />
        </div>
        <h1 className="mt-6 font-heading text-3xl leading-tight" data-testid="payment-cancel-title">
          {t("payment.cancel.title")}
        </h1>
        <p className="mt-4 text-base text-foreground/75 leading-relaxed">{t("payment.cancel.text")}</p>
        <Link
          to="/"
          data-testid="payment-cancel-back"
          className="mt-8 pill-btn bg-primary text-primary-foreground hover:bg-primary/90 inline-flex justify-center"
        >
          {t("payment.back")}
        </Link>
      </div>
    </main>
  );
}
